module.exports = __webpack_public_path__ + "static/media/starfish.bde521fa.png";